import { I18n } from "@assets/strings";
import React, { useMemo } from "react";
import styled, { css } from "styled-components";
import { TextSection } from "@domain/lms/course/courseSection";
import { RichTextInput } from "@ui/components/inputs/draft/richTextInput";
import { useChapterController } from "@ui/pages/lms/courseEditorPage/courseEditorController/editorControllerContext";

interface TextSectionEditorProps extends React.HTMLAttributes<HTMLDivElement> {
	section: TextSection;
	collapsed?: boolean;
	onExtend?: () => void;
}
export const TextSectionEditor: React.FC<TextSectionEditorProps> = ({
	section,
	collapsed = false,
	onExtend,
	...htmlProps
}) => {
	const chapterController = useChapterController();
	const textController = useMemo(() => chapterController.textSectionController(section), [section]);

	return (
		<Container {...htmlProps}>
			<StyledTextInput
				collapsed={collapsed}
				onClick={() => collapsed && onExtend && onExtend()}
				placeholder={I18n.t("course.editor.section.text.placeholder")}
				value={section.content}
				onChange={(v) => textController.setContent(v)}
				onKeyDown={(e) => {
					if (e.key === "Backspace" && !section.content.hasText()) {
						textController.removeSection();
					}
				}}
				readOnly={collapsed}
				richStyleEnabled={!collapsed}
			/>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
	margin: -10px -16px;
	line-height: 24px;
`;

const StyledTextInput = styled(RichTextInput)<{ collapsed: boolean }>`
	cursor: text;

	.public-DraftEditor-content,
	.public-DraftEditorPlaceholder-root {
		padding: 10px 32px 10px 16px;
	}
	${({ collapsed }) =>
		collapsed
			? css`
					height: 39px;
					overflow: hidden;
				`
			: css`
					min-height: 80px;
				`}
`;
